import "./App.css";
import { lazy, Suspense } from "react";
import { Route } from "react-router-dom";
import { AppRouter, AuthKeycloak } from "@artprov/design-system";
import ToastHost from "./common/components/alert/ToastHost.jsx";

// Cada pantalla se baja recién cuando se navega a ella (code splitting por ruta).
const Inicio = lazy(() => import("./pages/propuestas/index.jsx"));
const PublicInfoPage = lazy(() => import("./pages/public-info/index.jsx"));
const PaginaAutorizaciones = lazy(() => import("./pages/autorizaciones/index.jsx"));
const PaginaSimulaciones = lazy(() => import("./pages/simulaciones/index.jsx"));
const PaginaDetalleSimulacion = lazy(() => import("./pages/simulaciones/detalle/index.jsx"));
const PaginaSimulador = lazy(() => import("./pages/simulador/index.jsx"));

const conSuspense = (element) => <Suspense fallback={null}>{element}</Suspense>;

function App() {
  return (
    <>
      <AppRouter>
        <Route path="/public" element={conSuspense(<PublicInfoPage />)} />
        <AuthKeycloak
          keycloakConfig={{
            url: import.meta.env.VITE_KEYCLOAK_URL,
            realm: import.meta.env.VITE_KEYCLOAK_REALM,
            clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
          }}
          apiConfig={{
            consumidor: "Conciliaciones",
            services: [
              {
                name: "default",
                baseURL: import.meta.env.VITE_API_GATEWAY,
              },
            ],
          }}
          accessRole="acceso-conciliaciones"
        >
          <Route path="/" element={conSuspense(<Inicio />)} />
          <Route path="/simulaciones" element={conSuspense(<PaginaSimulaciones />)} />
          <Route path="/simulaciones/:id_simulacion" element={conSuspense(<PaginaDetalleSimulacion />)} />
          <Route path="/autorizaciones" element={conSuspense(<PaginaAutorizaciones />)} />
          <Route path="/simulador/:id_juicio?/:ex_id?" element={conSuspense(<PaginaSimulador />)} />
        </AuthKeycloak>
      </AppRouter>
      <ToastHost />
    </>
  );
}

export default App;
